var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('match-page-result-hockey')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }